// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"622":"51688a61","787":"b0434bf0"}[chunkId] + ".chunk.css";
};